
/* eslint-disable consistent-return */
import tracking from '@finn-no/analytics';
import delegate from 'delegate';
import recommendationTemplate from './recommendation-template';

export default win => {
    const element = win.document.getElementById(
        'employer-profile-recommendations',
    );
    if (!element) {
        // Likely due to fallback markup
        return;
    }

    function track(dataMode, href) {
        tracking.trackEventLater({
            analyticsName: `navigation.recommended-employer-profile-${dataMode}.click`,
            stringValue: href.toString(),
            ecType: 'USER',
            ecCategory: `${dataMode}-employer.m-job-front.click`,
        });
    }

    const publicPathname = element.getAttribute('data-resource-mount-path');

    const url = new win.URL(`${publicPathname}/data`, win.location);
    return win
        .fetch(url.toString(), { credentials: 'same-origin' })
        .then(res => (res.ok ? res.json() : Promise.reject(res)))
        .then(({ profiles, mode }) => {
            if (profiles.length > 0) {
                element.classList.add('panel');
                element.setAttribute('title', 'Bedriftsprofiler');
                element.innerHTML = recommendationTemplate(
                    profiles,
                    mode,
                );
                delegate(
                    element,
                    '.tracked-recommended-employer-profile',
                    'click',
                    e => {
                        track(
                            e.delegateTarget.getAttribute('data-mode'),
                            e.delegateTarget.getAttribute('href'),
                        );
                    },
                );
            }
        });
};
